"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parsedData = void 0;

var _flexSpotJson = _interopRequireDefault(require("@demant/react-bootstrap/lib/schemas/flex-spot-json"));

var _reactBootstrap = require("@demant/react-bootstrap");

var _App = _interopRequireDefault(require("./App"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var c = new _reactBootstrap.ComponentBootstrap('.flex-spot.preparation-tool-flex-spot:not(.custom)');
c.schemaData = _flexSpotJson["default"];
c.reactApp = _App["default"];
c.run();
var parsedData = c.parsedDataObject;
exports.parsedData = parsedData;